import * as yup from 'yup';

import { makeValidate } from '@occc-app/design-system';
import {
  IS_REQUIRED,
  IS_LATITUDE_VALID_RANGE,
  IS_LONGITUDE_VALID_RANGE,
  IS_ZIP_CODE,
} from '@occc-app/lib/constants/validationMessages';
import { AddressInput, GeoLocationInput } from '@occc/graphql';

import { LocationUpdateFormData } from './LocationUpdatePage/types';
import { LocationCreateFormData } from './LocationCreatePage/types';

const geoLocationSchema = yup.object<GeoLocationInput>({
  latitude: yup
    .number()
    .min(-90, IS_LATITUDE_VALID_RANGE)
    .max(90, IS_LATITUDE_VALID_RANGE)
    .required(IS_REQUIRED)
    .test('longitude', 'Latitude cannot be submitted without longitude.', function () {
      return this.parent.longitude !== undefined;
    }),
  longitude: yup
    .number()
    .min(-180, IS_LONGITUDE_VALID_RANGE)
    .max(180, IS_LONGITUDE_VALID_RANGE)
    .required(IS_REQUIRED)
    .test('latitude', 'Longitude cannot be submitted without latitude.', function () {
      return this.parent.latitude !== undefined;
    }),
});

const locationConfigurationSchema = yup
  .object<LocationUpdateFormData | LocationCreateFormData>()
  .shape({
    address: yup.object<AddressInput>().shape({
      street1: yup.string().required(IS_REQUIRED),
      city: yup.string().required(IS_REQUIRED),
      state: yup.object().required(IS_REQUIRED),
      countryCode: yup.string().required(IS_REQUIRED),
      zipCode: yup
        .string()
        .matches(/^\d{5}(-?\d)*$/, IS_ZIP_CODE)
        .required(IS_REQUIRED),
      geoLocation: geoLocationSchema.nullable().default(undefined).notRequired(),
    }),
    altriaRcn: yup.string().optional().nullable(),
    altriaMan: yup.string().optional().nullable(),
    rjrAccountNumber: yup.string().optional().nullable(),
    timezone: yup.object().required(IS_REQUIRED),
    locationGroups: yup
      .array()
      .of(
        yup.object({
          uuid: yup.string().required(IS_REQUIRED),
          name: yup.string().required(IS_REQUIRED),
        }),
      )
      .optional()
      .nullable(),
  });

export const validateLocationForm = makeValidate(locationConfigurationSchema);
